import { CircularProgress } from "@mui/material";
import { Button } from "pepsico-ds";
import { useState } from "react";
import { useToast } from "../../../hooks/useToast";
import { exportWithPolling } from "../../../utils/fileTransfer";
import ToastNotification from "../toastNotification/ToastNotification";

const ExportOptionsButton = ({
  context,
  parameters = {},
  exportType = "text/csv",
  filename = null,
}) => {
  const [isExporting, setIsExporting] = useState(false);
  const { toast, showToast, closeToast } = useToast();

  const handleExport = async () => {
    if (!context) {
      showToast("error", "Error", "Context not found");
      return;
    }

    setIsExporting(true);

    try {
      const result = await exportWithPolling({
        context,
        parameters,
        exportType,
        filename,
        maxAttempts: 300,
        polling: false,
      });
      if (result.status === 200) {
        showToast("success", result.message, result.description);
      }
    } catch (error) {
      showToast(
        "error",
        "Export Failed",
        error.message || "Failed to export. Please try again."
      );
    } finally {
      setIsExporting(false);
    }
  };
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <ToastNotification {...toast} handleClose={() => closeToast()} />
      {isExporting ? (
        <div style={{ display: "flex", alignItems: "center", minWidth: "125px" }}>
          <Button
            size="medium"
            text="Exporting..."
            variant="primary"
            disabled={true}
            style={{ minWidth: "125px" }}
          />
          <CircularProgress
            size={20}
            style={{
              marginLeft: -28,
            }}
          />
        </div>
      ) : (
        <Button
          size="medium"
          text="Export"
          variant="primary"
          iconLeading="file_download"
          onClick={handleExport}
          style={{ minWidth: "125px" }}
        />
      )}
    </div>
  );
};

export default ExportOptionsButton;
